import {fetchAndDeserialize, serializeToURLParameters} from '../../../util/api-adapter';
import {objectToUrlParameters} from '../../../util/url';

import {
    reviewRateCompetitorsResponseSchema,
    ReviewRateCompetitorsResponseType,
    ReviewsAnalysisRateQueryType,
} from './review-rate-type';

export async function fetchReviewRateCompetitors(
    options: ReviewsAnalysisRateQueryType,
    mainFilterKey: string
): Promise<ReviewRateCompetitorsResponseType> {
    const searchParameters = objectToUrlParameters({
        ...serializeToURLParameters<ReviewsAnalysisRateQueryType>(options),
        filter_key: mainFilterKey,
    });

    const url = `/v2/reviews-analytics/stats/rating-dynamic/?${searchParameters}`;

    return fetchAndDeserialize<ReviewRateCompetitorsResponseType>(url, reviewRateCompetitorsResponseSchema);
}
